import { PiMicrosoftTeamsLogo } from "react-icons/pi";
import { SiGooglemeet, SiZoom } from "react-icons/si";
import type { IconType } from "react-icons";
import { IntegrationProvider } from "../../domain/types";

/**
 * The provider's own mark beside an integration row.
 *
 * These are the real logos, from the Simple Icons set `react-icons` already
 * bundles. Using a company's mark to identify an integration with that company
 * is what both Zoom's and Google's brand guidelines permit, so they are drawn
 * unaltered and in the brand colour rather than approximated. Simple Icons
 * carries no Microsoft marks, so Teams comes from the Phosphor set, in Teams
 * purple.
 */
const BRAND: Record<IntegrationProvider, { Icon: IconType; color: string }> = {
    zoom: { Icon: SiZoom, color: "#0B5CFF" },
    google: { Icon: SiGooglemeet, color: "#00832D" },
    microsoft: { Icon: PiMicrosoftTeamsLogo, color: "#5B5FC7" },
};

export default function PlatformIcon({
    provider,
    size = 28,
}: {
    provider: IntegrationProvider;
    size?: number;
}) {
    const { Icon, color } = BRAND[provider];

    // The row already names the provider, so the mark would only repeat it.
    return <Icon aria-hidden="true" focusable="false" size={size} color={color} />;
}
